import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createCheckout } from '../services/api';
import './Checkout.css';

function Checkout() {
  const location = useLocation();
  const navigate = useNavigate();
  const product = location.state?.product;

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!product) {
    return (
      <div className="checkout-page">
        <div className="container">
          <div className="error-container">
            <h2>No Product Selected</h2>
            <p>Please select a product first.</p>
            <button onClick={() => navigate('/products')} className="btn btn-primary">
              Browse Products
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const checkoutData = await createCheckout({
        product_id: product.id,
        email: email,
        quantity: 1
      });

      // Redirect to SellAuth checkout page
      if (checkoutData.checkout_url || checkoutData.url) {
        window.location.href = checkoutData.checkout_url || checkoutData.url;
      } else {
        setError('Failed to create checkout session. Please try again.');
      }
    } catch (err) {
      console.error('Checkout error:', err);
      setError(err.response?.data?.message || 'Failed to process checkout. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="checkout-page">
      <div className="container">
        <div className="checkout-container">
          <div className="checkout-header">
            <h1>Checkout</h1>
            <p>Complete your purchase</p>
          </div>

          <div className="checkout-content">
            <div className="checkout-form-section">
              <div className="card">
                <h2>Customer Information</h2>
                <form onSubmit={handleSubmit} className="checkout-form">
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="your@email.com"
                      className="form-input"
                      required
                    />
                    <small>Your key will be delivered to this email</small>
                  </div>

                  {error && (
                    <div className="error-message">
                      <p>{error}</p>
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="btn btn-primary btn-large btn-full"
                    disabled={loading}
                  >
                    {loading ? 'Processing...' : 'Continue to Payment'}
                  </button>
                </form>
              </div>
            </div>

            <div className="checkout-summary">
              <div className="card">
                <h2>Order Summary</h2>
                
                <div className="summary-product">
                  <div className="summary-product-image">
                    <div className="placeholder-image-small">
                      <p>📦</p>
                    </div>
                  </div>
                  <div className="summary-product-info">
                    <h3>{product.title || product.name}</h3>
                    <p className="product-type">Digital Product</p>
                  </div>
                </div>

                <div className="summary-details">
                  <div className="summary-row">
                    <span>Subtotal</span>
                    <span>${product.price || '0.00'}</span>
                  </div>
                  <div className="summary-row">
                    <span>Tax</span>
                    <span>Calculated at checkout</span>
                  </div>
                  <div className="summary-divider"></div>
                  <div className="summary-row summary-total">
                    <span>Total</span>
                    <span>${product.price || '0.00'}</span>
                  </div>
                </div>

                <div className="checkout-features">
                  <div className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span>Instant delivery</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">🔒</span>
                    <span>Secure payment</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">💬</span>
                    <span>24/7 support</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checkout;
